import { boot } from '@dazn/bootstrap-lib';

const padWithZeros = (length: number, str: string): string => {
    const arr = str.split('');

    while (arr.length < length) {
        arr.unshift('0');
    }

    return arr.join('');
};

const _createDeviceId = (): string => {
    const rand = Math.random();
    const mersennePrime = 2147483647; // https://en.wikipedia.org/wiki/2,147,483,647

    const aBigNumber = Math.floor(rand * mersennePrime);
    const HEX = 16;
    const DEC = 10;
    const hexString = aBigNumber.toString(HEX);
    const paddedString = padWithZeros(DEC, hexString);

    return paddedString;
};

const getDeviceId = (
    load: boot.storage.AsyncStorage['getItem'],
    save: boot.storage.AsyncStorage['setItem'],
    createDeviceId: () => string = _createDeviceId,
): Promise<string> =>
    load('deviceId').then(id => {
        let deviceId = id;
        if (!deviceId) {
            deviceId = createDeviceId();
            save('deviceId', deviceId);
        }

        return deviceId;
    });

export { getDeviceId, _createDeviceId };
